var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcAttachmentmono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90312 4.39995C7.00312 2.29995 10.5031 2.29995 12.7031 4.39995L20.1031 11.8C21.7031 13.4 21.7031 15.9 20.1031 17.5C18.5031 19.1 16.0031 19.1 14.4031 17.5L8.40312 11.5C7.40312 10.5 7.40312 8.89996 8.40312 7.99996C9.40312 6.99996 11.0031 6.99996 11.9031 7.99996L16.5031 12.6C16.9031 13 16.9031 13.6 16.5031 14C16.1031 14.4 15.5031 14.4 15.1031 14L10.4031 9.29996C10.0031 8.89996 9.30313 9.59996 9.70313 9.99996L15.8031 16.1C16.6031 16.9 17.9031 16.9 18.6031 16.1C19.3031 15.3 19.4031 14 18.6031 13.3L11.2031 5.89995C9.80313 4.49995 7.60313 4.49995 6.30313 5.89995C5.00313 7.29995 4.90313 9.49996 6.30313 10.8L12.3031 16.8C12.7031 17.2 12.7031 17.8 12.3031 18.2C11.9031 18.6 11.3031 18.6 10.9031 18.2L4.90312 12.2C2.80313 10.1 2.80313 6.59995 4.90312 4.39995Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcAttachmentmono);
export default __webpack_public_path__ + "static/media/mai-ic-attachment.mono.799a6ed34a33e8b3ba899da5747877de.svg";
export { ForwardRef as ReactComponent };